import React, { useState, useEffect, useContext } from 'react'
import { EventListContext } from '../../../utils/context'
import styles from './styles.module.scss'
import Confirmation from '../../../components/Confirmation/Confirmation'
import { BiTrash } from 'react-icons/bi'
import Table from '../../../components/Table'
import PeopleModal from './Components/PeopleModal'
import ModalFooter from './Components/ModalFooter'
import { Input } from '../../../components/ModalInputs'


export default function ParticipantsEmployees() {

  const { event, closeModal, formik } = useContext(EventListContext)

  const { values, setFieldValue, handleSubmit } = formik
  const teacherMembers = values.teacher_members || []

  const [confirmation, setConfirmation] = useState(false);

  // Синхронизация с существующими данными при редактировании
  useEffect(() => {
    if (event?.participants && event.participants.length > 0 && teacherMembers.length === 0) {
      setFieldValue('teacher_members', event.participants.map(p => ({
        mid: p.mid,
        place: p.place || 0,
        fio: p.fio,
        calc_posts: p.calc_posts || p.post || '',
        pmbid: p.pmbid,
        is_prizer: p.is_prizer || false,
        is_winner: p.is_winner || false
      })))
    }
  }, [event?.participants])

  const onAddParticipantsEmployees = (person) => {
    const newTeacherMember = {
      mid: person.mid,
      place: 0,
      fio: person.calc_fio || person.fio,
      calc_posts: person.calc_posts || '',
      is_prizer: false,
      is_winner: false
    }
    setFieldValue('teacher_members', [...teacherMembers, newTeacherMember])
  }

  const acceptConfirmation = () => {
    const updated = teacherMembers.filter(t => t.pmbid !== confirmation.id && t.mid !== confirmation.id)
    setFieldValue('teacher_members', updated)
    setConfirmation(false);
  };

  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const handleTogglePrize = (mid, field) => {
    const index = teacherMembers.findIndex(t => t.mid === mid)
    if (index !== -1) {
      setFieldValue(`teacher_members[${index}].${field}`, !teacherMembers[index][field])
    }
  };

  const handlePlaceChange = (mid, value) => {
    const index = teacherMembers.findIndex(t => t.mid === mid)
    if (index !== -1) {
      setFieldValue(`teacher_members[${index}].place`, parseInt(value) || 0)
    }
  };

  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          {confirmation && (
            <Confirmation
              top="30px"
              left="40px"
              title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
              acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
              rejectConfirmation={rejectConfirmation}
            />
          )}
          <Table>
            <thead>
              <tr>
                <th>ФИО</th>
                <th>Должность</th>
                <th>Место</th>
                <th>Призер</th>
                <th>Победитель</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {teacherMembers.map((member) =>
                <tr key={member.pmbid || member.mid}>
                  <td>{member.fio}</td>
                  <td>{member.calc_posts || ''}</td>
                  <td>
                    <Input
                      type="number"
                      value={member.place || ''}
                      onChange={(e) => handlePlaceChange(member.mid, e.target.value)}
                      style={{ width: '60px' }}
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      checked={member.is_prizer || false}
                      onChange={() => handleTogglePrize(member.mid, 'is_prizer')}
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      checked={member.is_winner || false}
                      onChange={() => handleTogglePrize(member.mid, 'is_winner')}
                    />
                  </td>
                  <td>
                    <i
                      className={styles.trash}
                      onClick={() => setConfirmation({ id: member.pmbid || member.mid, name: member.fio })}
                    >
                      <BiTrash />
                    </i>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <PeopleModal onSubmit={onAddParticipantsEmployees} />
        </div>
      </div>
      <ModalFooter
        event={event}
        onSave={handleSubmit}
        onClose={closeModal}
        showCheckbox={false}
      />
    </>
  )
}
